import PropTypes from 'prop-types';
import XFormInput from "../../Utils/Form/XFormInput/index.jsx";
import inputTypes from "../../Utils/Form/FormInput/inputTypes.jsx";
import {emailValidator, organizationNameValidator, phoneNrValidator} from "../../../Utils/index.js";
import React from "react";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";

function OrganizationForm({readOnly = false}) {
    const {t} = useTranslation();
    const {register} = useFormContext()

    return (
        <fieldset className='form__section'>
            <legend className='form__section-label form__section-label--3column'>
                <span>{t('details')}</span>
            </legend>
            <XFormInput
                readOnly={readOnly}
                id={'organization_name'}
                type={inputTypes.text}
                name={'organization_name'}
                label={t('organization_name')}
                placeholder={t('type_the_organization_name')}
                ref={register('organization_name', {
                    required: 'error_field_required',
                    validate: organizationNameValidator
                })}
            />

            <XFormInput
                readOnly={readOnly}
                id={'contact_email'}
                type={inputTypes.text}
                name={'contact_email'}
                label={t('contact_email')}
                placeholder={t('type_the_contact_email')}
                ref={register('contact_email', {
                    required: 'error_field_required',
                    validate: emailValidator
                })}
            />

            <XFormInput
                readOnly={readOnly}
                id={'contact_phone'}
                type={inputTypes.tel}
                name={'contact_phone'}
                label={t('contact_phone_number')}
                placeholder={t('type_the_contact_phone_number')}
                ref={register('contact_phone', {
                    required: 'error_field_required',
                    validate: phoneNrValidator
                })}
            />
        </fieldset>
    );
}

export default OrganizationForm;

OrganizationForm.propTypes = {
    readOnly: PropTypes.bool
};
